<template>
  <div>
    <PcHead></PcHead>
    <router-view></router-view>
    <PcFooter></PcFooter>
  </div>
</template>
<script>
import PcHead from '@/components/Pc/Head.vue';
import PcFooter from '@/components/Pc/Footer.vue';
export default {
  components:{
    PcHead,
    PcFooter
  },
  data(){
    return {
      index:0
    }
  }
}
</script>
<style lang="less" scoped>
.p-title{
  height:32px;
  font-size:24px;
  font-family:NotoSansHans-Regular;
  font-weight:400;
  color:rgba(51,51,51,1);
  line-height:32px;
  text-align: center;
}
</style>
